import styled from 'styled-components';
import {mobileMedia, STRONG_BLUE, DARK_GRAY2, LIGHT_GRAY5, WHITE, dFlexCenter, RED} from '../../../globalVariables/GlobalVariables';
import {wrap} from '../../../component/textEditor/TextEditor.css';
import {btn} from '../../../component/button/btn/Btn.css';
import {dFlexEnd, dFlex} from '../../../globalVariables/GlobalFlex';
import zIndex from '../../../globalVariables/zIndex';

export const wrapEditor = styled.div`
    border: 2px solid ${STRONG_BLUE};
    border-radius: 10px;
    padding: 0 0 10px 0;
    position: relative;
    width: 100%;
    ${wrap}{
        border: none;
    }
    .ql-toolbar.ql-snow {
        border-bottom: none;
        position: absolute;
        bottom: 0px;
        z-index: ${zIndex.baseRaised};
        ${p => p.direction==='ltr' ? 'inset-inline-end': 'inset-inline-start'}: 10px;
    }
`;
export const buttons = styled.div`
    ${dFlexEnd};
    min-height: 40px;
    /* justify-content: space-between; */
    border-top: 1px solid ${LIGHT_GRAY5};
    width: 94%;
    margin: 0 auto;
    position: relative;
    padding-block: 10px;
    ${btn} {
      min-width: 100px;
    }
    ${mobileMedia}{
        padding: 10px;
    }
`;

export const prefix = styled.div`
    top: 60px;
    inset-inline-start: ${p => p.direction==='ltr' ? '17px' : '27px'};
    direction: ${p => p.direction};
    position: relative;
    color: ${DARK_GRAY2};
    white-space: pre-line;
    opacity: 0.5;
    width: calc(100% - 35px);
    ${mobileMedia}{
        inset-inline-start: 10px;
    }
`;

export const suffix = styled.div`
    bottom: 5px;
    inset-inline-start: ${p => p.direction==='ltr' ? '17px' : '27px'};
    direction: ${p => p.direction};
    position: relative;
    white-space: pre-line;  
    color: ${DARK_GRAY2};
    padding-bottom: 12px;
    opacity: 0.5;
    width: calc(100% - 35px);
    ${mobileMedia}{
        inset-inline-start: 10px;
    }
`;

export const button = styled.div`
    width: 121px;
    height: 35px;
    background: ${WHITE};
    border-radius: 5px;
    border: 0.50px ${LIGHT_GRAY5} solid;
    text-align: center;
    padding-block: 8px;
`;
export const suffixButtons = styled.div`
    ${dFlex}
    gap: 10px;
    margin-top: 10px;
`;
export const whatsappWarning = styled.div`
    position: absolute;
    top: 20px;  
    ${p => (p.theme.rtl && p.direction==='ltr') || (!p.theme.rtl && p.direction==='rtl') ? 'inset-inline-end': 'inset-inline-start'}: 20px;
    width: max-content;
    height: max-content;
    padding-inline: 5px;
    ${dFlexCenter};
    z-index: ${zIndex.baseRaised};
    color: ${RED};
    &::before{
        content: '!';
        position: relative;
        background-color: ${RED};
        border-radius: 50%;
        color: ${WHITE};
        padding-inline: 7px;
        font-weight: 700;
        margin-inline-end: 5px;
    }
`;
